import _ from 'lodash';


window.INZ = window.INZ || {};
window.INZ._ = _;

export default window.INZ;




// WEBPACK FOOTER //
// ./src/inz.js